
const PLACE_HOLDER_PATTERN = new RegExp("{([a-zA-z_.#|])+}","g");
Array.prototype.shuffle = function () {
    return this.map((a) => ({ sort: Math.random(), value: a }))
        .sort((a, b) => a.sort - b.sort)
        .map((a) => a.value);
};

Array.prototype.remove = function (value) {
    const i = this.indexOf(value);
    i > -1 && this.splice(i,1);
    return this;
};

Array.prototype.toMap = function (key,valueF=(e)=>e) {
    return this.reduce((m,e)=>{m[e[key]]=valueF(e);return m},{});
}
Array.prototype.includesAll= function(values) {
    const self = this;
    return values.every(value => self.includes(value));
}
Array.prototype.included= function(val,matchKeys) {
    return typeof val == 'object'?!!this.find(v=>deepEqual(v,val,matchKeys)):this.includes(val);
}
Array.prototype.toArray = function() {
    return this;
}
Boolean.prototype.eq = function(v){return this == Boolean(v);}
String.prototype.eq = function(v){return this == String(v);}
String.prototype.toArray = function (delimiter =","){
    return this == ""?[]:this.split(delimiter);
}
String.prototype.ellipsis = function (maxLeng,ellipsisText="..."){
    return `${this.substring(0,maxLeng)}${this.length>maxLeng?ellipsisText:''}`;
}
String.prototype.getCxtValue = function (values={},defaultValue=''){
    let v = values
    const fds = this.split('.');
    fds.forEach(f=>{
        if(v?.hasOwnProperty(f)){
            v = v[f]
        }
        else{
            v = defaultValue
        }
    })
    return {value:v,ctxt:fds.length>1?fds[0]:null};
}
String.prototype.resolvePlaceholder = function (values={},dValue=undefined,nonMatchValue=this.toString()){
    let str = this.toString(),match,noMatch=true;
    while ((match = PLACE_HOLDER_PATTERN.exec(this)) !== null) {
        noMatch = false;
        let mtexts = match[0].substring(1,match[0].length-1).split('|');
        const val = (mtexts = mtexts.map(mtext=>typeof values == 'function'? values(mtext):mtext.getCxtValue(values,dValue))).find(v=>v.value!=undefined && v.value!=dValue) || mtexts[0];
        val.value == undefined && (val.value=dValue);
        (val.value != undefined) && (str = str.replace(match[0],val.value.constructor.name == 'Object'?(val.value?.value||val.value):val.value))
    }
    return noMatch?nonMatchValue:str;
}
window.deepEqual = (x, y,matchKeys)=> {
    const ok = Object.keys, tx = typeof x, ty = typeof y;
  return x && y && x.constructor.name == 'Array' && x.length === y.length? x.every(value=>y.included(value,matchKeys)):x && y && tx === 'object' && tx === ty ? (
    (ok(x).length === ok(y).length || matchKeys?.length)&&
      ok(x).every(key => (matchKeys && !matchKeys.includes(key)) || deepEqual(x[key], y[key]))
  ) : (x === y);
}
window.deepMerge = (x, y)=> {
    const ok = Object.keys, tx = typeof x, ty = typeof y,m={...x,...y};
    if((x|| y) && (x|| y).constructor.name == 'Array'){
        return y || x;
    }
    else if(x && y && tx === 'object' && tx === ty){
        ok(x).forEach(key => {
            let cv = deepMerge(x[key],y[key]);
            if(Object.keys(cv).length){
                m[key] = cv;
            }
        })
    }
    else if(tx != 'object' && ty != 'object') return {}
    
    return m;
}
window.getFromStorage = (key)=>{
    const value = localStorage.getItem(key);
    return value?JSON.parse(value):{}
};
window.setToStorage = (key,value)=>{
    localStorage.setItem(key,JSON.stringify(value));
}